import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import { Switch, Route } from 'react-router-dom';
import { createWorkshop, updateWorkshop, fetchWorkshop, WorkshopSessionTimes } from './actions';
import WorkshopForm from './SettingsForm';
import Sessions from './Sessions';
import BackButton from '../../common/components/BackButton';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui'

class Details extends Component {

	constructor(props) {
		super(props);
		this.handleWorkshopSettingsSubmit = this.handleWorkshopSettingsSubmit.bind(this);
		this.handleTabSelect = this.handleTabSelect.bind(this);
	}

	componentDidMount() {
		const { match, fetchWorkshop } = this.props;
		const workshopId = match.params.id;
		if (workshopId) {
			fetchWorkshop(workshopId);
		}
	}

	handleWorkshopSettingsSubmit(values) {
		const { workshop, createWorkshop, updateWorkshop, history } = this.props;

		if (workshop) {
			updateWorkshop(workshop.id, values);
		} else {
			const { daysOfWeek } = values;
			const daysOfWeekBitwise = daysOfWeek && daysOfWeek
				.map(entry => entry.value)
				.reduce((accumulator, currentValue) => accumulator | currentValue);

			createWorkshop({ ...values, daysOfWeek: daysOfWeekBitwise }, history);
		}
	}

	handleTabSelect(key) {
		this.props.history.replace(`/workshops/${this.props.workshopId}/${key}`);
	}

	render() {
		const { match, workshop, isReadonly, recurrenceDaysOfWeek, franchisor, t } = this.props;
		const selectedTab = match.params.tab || 'workshop';
		const publicPageUrl = workshop && `${franchisor.frontOfficeUrl}/public/workshops/${workshop.centerId}/${workshop.id}`;

		return (<div>
			<BackButton style={{ marginBottom: '10px' }}>{t('Common_BackToList')}</BackButton>
			{workshop && <a href={publicPageUrl} target='_blank'
				className='btn btn-info' style={{ marginLeft: '5px', marginBottom: '10px' }}>{t('Workshop_PublicPage')}</a>}
			<Tabs defaultActiveKey={selectedTab} id='workshop-tabs' onSelect={this.handleTabSelect}>
				<Tab eventKey='workshop' title={t('Workshop_Tab_Details')}>
					<WorkshopForm form={match.params.id ? 'workshop' : 'newWorkshop'} isReadonly={isReadonly}
						initialValues={workshop ? workshop : {
							id: 0,
							morningStartTime: ui.adjustDate(WorkshopSessionTimes.MorningStartTime, 0, 0),
							morningEndTime: ui.adjustDate(WorkshopSessionTimes.MorningEndTime, 0, 0),
							afternoonStartTime: ui.adjustDate(WorkshopSessionTimes.AfternoonStartTime, 0, 0),
							afternoonEndTime: ui.adjustDate(WorkshopSessionTimes.AfternoonEndTime, 0, 0)
						}}
						onSubmit={this.handleWorkshopSettingsSubmit} recurrenceDaysOfWeek={recurrenceDaysOfWeek} publicPageUrl={publicPageUrl} />
				</Tab>
				{workshop && <Tab eventKey='sessions' title={t('Workshop_Tab_Sessions')}>
					<Switch>
						<Route path={`/workshops/${workshop.id}/sessions`} exact render={props => <Sessions workshopId={workshop.id} isReadonly={isReadonly} />} />
					</Switch>
				</Tab>}
			</Tabs>
		</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const id = ownProps.match.params.id;

	const {
		entities: { workshops },
		auth: { currentUser },
		lookups: { recurrenceDaysOfWeek },
		configuration: { franchisor }
	} = state;

	return {
		currentUser,
		workshopId: id,
		workshop: workshops[id],
		recurrenceDaysOfWeek,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Workshops'),
		franchisor
	};
};

const mapDispatchToProps = {
	createWorkshop,
	updateWorkshop,
	fetchWorkshop
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Details));